import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function VisitReportDelConfirm(props) {
    const [open, setOpen] = useState(false)
    const handleClose = () => {
        props.cancelClick();
    };

    const handleOpen = () => {
        props.deleteClick();
    }

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"訪問記録削除確認"}
                </DialogTitle>
                <DialogContent>
                    <div>
                        下記、訪問記録を削除します。<br />
                        <p />
                        工事コード:{props.kojiCD}<br />
                        帳票種別：{props.rptShubetsu}<br />
                        管理No:{props.mngNo}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button type="button" onClick={handleOpen}>確定</Button>
                    <Button type="button" onClick={handleClose}>キャンセル</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}